import getMetaElements from "shared/components/MetaTags/getMetaElements"
import getMetaTagsString from "shared/components/MetaTags/getMetaTagsString"
import { getSmallestImage } from "shared/helpers/ssr"

/**
 * функция отвечает за формирование шаблона в блоке head разметки
 */
export const getHeadTemplate = ({props, activeRoute, objProps }: any) => {
    const { teamRu, notFound } = props
    const { req } = objProps
    const hostOrig = req.get('host')
    const host = hostOrig.split('.')[0]
    const hostName = host ? host.charAt(0).toUpperCase() + host.slice(1) : ''
    if (!teamRu) return 
    const teamAbout = teamRu.about
    const pageTitle = teamRu.name
    const pageDescription = teamAbout   //возможно надо сюда тегов со страницы дизайнера добавить
    const smallestImage = getSmallestImage(teamRu.titleImages);
    const ogImage = smallestImage ? smallestImage.url : '';

    const imageUrl = `https://files.mediiia.ru/${ogImage}`

    const elements = getMetaElements({title: pageTitle, imageUrl, description: [pageDescription]})

    const metaTags = getMetaTagsString(elements)

    return `
        <title>${pageTitle}</title>
        ${metaTags}
    `
}import getMetaElements from "shared/components/MetaTags/getMetaElements"
import getMetaTagsString from "shared/components/MetaTags/getMetaTagsString"
import { getSmallestImage } from "shared/helpers/ssr"

/**
 * функция отвечает за формирование шаблона в блоке head разметки
 */
export const getHeadTemplate = ({props, activeRoute, objProps }: any) => {
    const { teamRu, notFound } = props
    const { req } = objProps
    const hostOrig = req.get('host')
    const host = hostOrig.split('.')[0]
    const hostName = host ? host.charAt(0).toUpperCase() + host.slice(1) : ''
    if (!teamRu) return 
    const teamAbout = teamRu.about
    const pageTitle = teamRu.name
    const pageDescription = teamAbout   //возможно надо сюда тегов со страницы дизайнера добавить
    const smallestImage = getSmallestImage(teamRu.titleImages);
    const ogImage = smallestImage ? smallestImage.url : '';

    const imageUrl = `https://files.mediiia.ru/${ogImage}`

    const elements = getMetaElements({title: pageTitle, imageUrl, description: [pageDescription]})

    const metaTags = getMetaTagsString(elements)

    return `
        <title>${pageTitle}</title>
        ${metaTags}
    `
}